import { MarketSelectorStoreModuleFactory } from '../market-selector/index.module.js';
import { CompanyLogoStoreModuleFactory } from '../company-logo/index.module.js';
import { BasicValueUnitGetModuleFactory } from '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import { InstrumentGetByNotationModuleFactory } from '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import { NotationKeyFiguresGetModuleFactory } from '../../endpoints/notation/keyFigures/get.module.js';
import { NotationGetModuleFactory } from '../../endpoints/notation/get.module.js';
import { PricesListModuleFactory } from '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import { FundShareClassGetModuleFactory } from '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import { SecuritizedDerivativeGetModuleFactory } from '../../endpoints/securitizedDerivative/get.module.js';
import { CompanyKeyItemsFiscalYearListByInstrumentModuleFactory } from '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import { MorningstarFundGetModuleFactory } from '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import { CompanyEstimatesListByInstrumentModuleFactory, COMPANY_ESTIMATES_SUPPORTED_CURRENCIES } from '../../endpoints/company/estimates/listByInstrument.module.js';
import { MorningstarFundCategoryListByInstrumentModuleFactory } from '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import { MorningstarFundIssuerGetModuleFactory } from '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import { NotationStatusGetModuleFactory } from '../../endpoints/notation/status/get.module.js';
import { InstrumentCompliancePropertyListByInstrumentModuleFactory } from '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import '../../endpoints/portfolio/position/list.module.js';
import '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import { IndexGetModuleFactory } from '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import '../../subscriptions/news/article/searchByText.module.js';
import '../../subscriptions/news/article/listByMediaKind.module.js';
import { PricesGetSubscriptionModuleFactory } from '../../subscriptions/prices/get.module.js';
import '../../subscriptions/prices/bidAsk/get.module.js';
import '../../subscriptions/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../subscriptions/alerting/prices/basic/alert/list.module.js';
import '../../subscriptions/prices/orderbook/aggregated/get.module.js';
import { inheritEndpointOptions, getEndpointOptions, convertMdg2DateTimeResponse, getLanguage, mapAssetClass, FactsetFxMarket } from '../../helpers/common.js';
import 'lodash.set';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';

var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
class FactsheetHeaderStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.defaultNameType = "name";
    this.defaultFallbackForNameType = true;
    this.defaultFundProvider = "mountainview";
    this.fundCategoryType = 53406;
    this.peaID = 2;
    this.peapmeID = 3;
    this.srdID = 4;
    this.derivatives = ["option", "future", "interestRate", "investmentProduct", "leveragedProduct"];
    this.quality = (_c = (_b = (_a = this.options) == null ? void 0 : _a.prices) == null ? void 0 : _b.quality) != null ? _c : "BST";
    this.sameQuality = (_f = (_e = (_d = this.options) == null ? void 0 : _d.prices) == null ? void 0 : _e.sameQuality) != null ? _f : false;
    this.isPushEnabled = (_i = (_h = (_g = this.options) == null ? void 0 : _g.push) == null ? void 0 : _h.enabled) != null ? _i : true;
    this.defaultLanguage = "en";
    this.longTermAssetClasses = ["index", "stock", "fund", "etf", "investmentProduct", "bond"];
    this.fundProvider = (_l = (_k = (_j = this.options) == null ? void 0 : _j.fund) == null ? void 0 : _k.provider) != null ? _l : this.defaultFundProvider;
    this.defaultCompanyEstimatesIsoCurrency = "USD";
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload)
    };
  }
  async updateComponentsInputs(payload) {
    let isResponseSuccessful = true;
    try {
      await Promise.all([
        this.updateInstrumentGetByNotationData(payload),
        this.updatePriceInformation(payload),
        this.updateFooterInformationData(payload),
        this.updatePerformanceBarData(payload)
      ]);
    } catch (e) {
      this.logger.error(e);
      isResponseSuccessful = false;
    }
    return isResponseSuccessful;
  }
  async cleanUp(payload) {
    if (this.isPushEnabled) {
      await this.removeInactivePricesSubscriptions(payload.id);
    }
    return true;
  }
  getDependencies() {
    var _a2, _b2, _c2;
    if (!this.dependencies) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      this.dependencies = {
        companyLogo: new CompanyLogoStoreModuleFactory({
          mdg2Client: this.mdg2Client,
          logger: this.logger,
          store: this.store,
          options: inheritEndpointOptions(endpointConfiguration, (_b2 = this.options) == null ? void 0 : _b2.companyLogo)
        }),
        marketSelector: new MarketSelectorStoreModuleFactory({
          mdg2Client: this.mdg2Client,
          logger: this.logger,
          store: this.store,
          options: inheritEndpointOptions(endpointConfiguration, (_c2 = this.options) == null ? void 0 : _c2.marketSelector)
        })
      };
    }
    return this.dependencies;
  }
  getEndpoints() {
    var _a2, _b2, _c2, _d2;
    if (!this.endpoints) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      const pricesGetSubscriptionOptions = {
        granularity: (_d2 = (_c2 = (_b2 = this.options) == null ? void 0 : _b2.push) == null ? void 0 : _c2.granularity) != null ? _d2 : "1S",
        quality: this.quality,
        ...getEndpointOptions(endpointConfiguration, "pricesGetSubscription")
      };
      this.endpoints = {
        basicValueUnitGet: this.getModuleEntity(BasicValueUnitGetModuleFactory, getEndpointOptions(endpointConfiguration, "basicValueUnitGet")),
        instrumentGetByNotation: this.getModuleEntity(InstrumentGetByNotationModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentGetByNotation")),
        pricesList: this.getModuleEntity(PricesListModuleFactory, getEndpointOptions(endpointConfiguration, "pricesList")),
        pricesGetSubscription: this.getModuleEntity(PricesGetSubscriptionModuleFactory, pricesGetSubscriptionOptions),
        indexGet: this.getModuleEntity(IndexGetModuleFactory, getEndpointOptions(endpointConfiguration, "indexGet")),
        notationKeyFiguresGet: this.getModuleEntity(NotationKeyFiguresGetModuleFactory, getEndpointOptions(endpointConfiguration, "notationKeyFiguresGet")),
        notationStatusGet: this.getModuleEntity(NotationStatusGetModuleFactory, getEndpointOptions(endpointConfiguration, "notationStatusGet")),
        notationGet: this.getModuleEntity(NotationGetModuleFactory, getEndpointOptions(endpointConfiguration, "notationGet")),
        morningstarFundCategoryListByInstrument: this.getModuleEntity(
          MorningstarFundCategoryListByInstrumentModuleFactory,
          getEndpointOptions(endpointConfiguration, "morningstarFundCategoryListByInstrument")
        ),
        morningstarFundGet: this.getModuleEntity(MorningstarFundGetModuleFactory, getEndpointOptions(endpointConfiguration, "morningstarFundGet")),
        morningstarFundIssuerGet: this.getModuleEntity(MorningstarFundIssuerGetModuleFactory, getEndpointOptions(endpointConfiguration, "morningstarFundIssuerGet")),
        instrumentCompliancePropertyListByInstrument: this.getModuleEntity(
          InstrumentCompliancePropertyListByInstrumentModuleFactory,
          getEndpointOptions(endpointConfiguration, "instrumentCompliancePropertyListByInstrument")
        ),
        companyEstimatesListByInstrument: this.getModuleEntity(
          CompanyEstimatesListByInstrumentModuleFactory,
          getEndpointOptions(endpointConfiguration, "companyEstimatesListByInstrument")
        ),
        companyKeyItemsFiscalYearListByInstrument: this.getModuleEntity(
          CompanyKeyItemsFiscalYearListByInstrumentModuleFactory,
          getEndpointOptions(endpointConfiguration, "companyKeyItemsFiscalYearListByInstrument")
        ),
        fundShareClassGet: this.getModuleEntity(FundShareClassGetModuleFactory, getEndpointOptions(endpointConfiguration, "fundShareClassGet")),
        securitizedDerivativeGet: this.getModuleEntity(SecuritizedDerivativeGetModuleFactory, getEndpointOptions(endpointConfiguration, "securitizedDerivativeGet"))
      };
    }
    return this.endpoints;
  }
  getResponseData(payload) {
    return {
      ...this.getInstrumentBasicInformation(payload),
      ...this.getPriceInformation(payload),
      baseInfo: this.getFooterInformationData(payload),
      performanceBar: this.getPerformanceBarData(payload)
    };
  }
  getPriceInformation(payload) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m, _n, _o, _p, _q, _r, _s, _t;
    const priceResponse = this.getPricesListData(payload);
    const valueUnit = priceResponse ? this.getBasicValueUnitData(priceResponse.valueUnit.id) : null;
    const pricesSubscriptionData = this.isPushEnabled ? this.getPricesSubscriptionData(payload) : null;
    return {
      lastPrice: (_b2 = (_a2 = pricesSubscriptionData == null ? void 0 : pricesSubscriptionData.latest.price) != null ? _a2 : priceResponse == null ? void 0 : priceResponse.latest.price) != null ? _b2 : null,
      currency: (_d2 = (_c2 = valueUnit == null ? void 0 : valueUnit.code) != null ? _c2 : valueUnit == null ? void 0 : valueUnit.isoCode) != null ? _d2 : null,
      lastPriceDateTime: convertMdg2DateTimeResponse((_f2 = (_e2 = pricesSubscriptionData == null ? void 0 : pricesSubscriptionData.latest.time) != null ? _e2 : priceResponse == null ? void 0 : priceResponse.latest.time) != null ? _f2 : null),
      performance: (_h2 = (_g2 = pricesSubscriptionData == null ? void 0 : pricesSubscriptionData.latest.performance.intraday.absolute) != null ? _g2 : priceResponse == null ? void 0 : priceResponse.latest.performance.intraday.absolute) != null ? _h2 : null,
      performanceRelative: (_j2 = (_i2 = pricesSubscriptionData == null ? void 0 : pricesSubscriptionData.latest.performance.intraday.relative) != null ? _i2 : priceResponse == null ? void 0 : priceResponse.latest.performance.intraday.relative) != null ? _j2 : null,
      volume: (_k2 = priceResponse == null ? void 0 : priceResponse.accumulated.tradingVolume) != null ? _k2 : null,
      lowPrice: (_m = (_l2 = pricesSubscriptionData == null ? void 0 : pricesSubscriptionData.low.price) != null ? _l2 : priceResponse == null ? void 0 : priceResponse.low.price) != null ? _m : null,
      lowPriceDateTime: convertMdg2DateTimeResponse((_o = (_n = pricesSubscriptionData == null ? void 0 : pricesSubscriptionData.low.time) != null ? _n : priceResponse == null ? void 0 : priceResponse.low.time) != null ? _o : null),
      highPrice: (_q = (_p = pricesSubscriptionData == null ? void 0 : pricesSubscriptionData.high.price) != null ? _p : priceResponse == null ? void 0 : priceResponse.high.price) != null ? _q : null,
      highPriceDateTime: convertMdg2DateTimeResponse((_s = (_r = pricesSubscriptionData == null ? void 0 : pricesSubscriptionData.high.time) != null ? _r : priceResponse == null ? void 0 : priceResponse.high.time) != null ? _s : null),
      quality: (_t = priceResponse == null ? void 0 : priceResponse.quality) != null ? _t : null
    };
  }
  getInstrumentBasicInformation(payload) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A;
    const instrumentResponse = this.getInstrumentGetByNotationData(payload);
    const assetClass = this.getAssetClass(payload);
    const nameType = (_l2 = (_k2 = (_e2 = (_d2 = (_c2 = (_b2 = (_a2 = this.options) == null ? void 0 : _a2.assetClass) == null ? void 0 : _b2[assetClass]) == null ? void 0 : _c2.instrument) == null ? void 0 : _d2.name) == null ? void 0 : _e2.type) != null ? _k2 : (_j2 = (_i2 = (_h2 = (_g2 = (_f2 = this.options) == null ? void 0 : _f2.assetClass) == null ? void 0 : _g2.generic) == null ? void 0 : _h2.instrument) == null ? void 0 : _i2.name) == null ? void 0 : _j2.type) != null ? _l2 : this.defaultNameType;
    const isNameTypeFallbackEnabled = (_x = (_w = (_q = (_p = (_o = (_n = (_m = this.options) == null ? void 0 : _m.assetClass) == null ? void 0 : _n[assetClass]) == null ? void 0 : _o.instrument) == null ? void 0 : _p.name) == null ? void 0 : _q.fallback) != null ? _w : (_v = (_u = (_t = (_s = (_r = this.options) == null ? void 0 : _r.assetClass) == null ? void 0 : _s.generic) == null ? void 0 : _t.instrument) == null ? void 0 : _u.name) == null ? void 0 : _v.fallback) != null ? _x : this.defaultFallbackForNameType;
    const nameFallback = isNameTypeFallbackEnabled ? instrumentResponse == null ? void 0 : instrumentResponse.name : null;
    return {
      name: (_z = (_y = instrumentResponse == null ? void 0 : instrumentResponse[nameType]) != null ? _y : nameFallback) != null ? _z : null,
      isin: (_A = instrumentResponse == null ? void 0 : instrumentResponse.isin) != null ? _A : null,
      assetClass
    };
  }
  getInstrumentGetByNotationData(payload) {
    var _a2;
    const request = this.getInstrumentGetByNotationRequest(payload.id, payload.language);
    const response = this.getEndpoints().instrumentGetByNotation.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getInstrumentId(payload) {
    const instrumentData = this.getInstrumentGetByNotationData(payload);
    if (!instrumentData) {
      throw new Error("Could not fetch the instrument id");
    }
    return instrumentData.id;
  }
  getInstrumentGetByNotationRequest(id, payloadLanguage) {
    const language = getLanguage(payloadLanguage, this.defaultLanguage, this.options);
    return { id, _language: language };
  }
  async updateInstrumentGetByNotationData(payload) {
    const request = this.getInstrumentGetByNotationRequest(payload.id, payload.language);
    return this.getEndpoints().instrumentGetByNotation.updateState(request);
  }
  getPricesListNotationDataRequest(id) {
    return { id, quality: this.quality, sameQuality: this.sameQuality };
  }
  getPricesListRequest(identifiers) {
    return { identifiers, identifierType: "idNotation", quality: this.quality, sameQuality: this.sameQuality };
  }
  getPricesListData(payload) {
    var _a2;
    const request = this.getPricesListNotationDataRequest(payload.id);
    const response = this.getEndpoints().pricesList.getNotationData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updatePricesList(ids) {
    const request = this.getPricesListRequest(ids);
    return this.getEndpoints().pricesList.updateState(request);
  }
  getPricesSubscriptionRequest(identifier) {
    return { identifier, identifierType: "idNotation", quality: this.quality };
  }
  getPricesSubscriptionData(payload) {
    var _a2;
    const request = this.getPricesSubscriptionRequest(payload.id);
    const response = this.getEndpoints().pricesGetSubscription.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updatePricesSubscription(payload) {
    const request = this.getPricesSubscriptionRequest(payload.id);
    return this.getEndpoints().pricesGetSubscription.fetchObservable(request);
  }
  async fetchPricesSubscriptionObservable(id) {
    const request = this.getPricesSubscriptionRequest(id);
    return this.getEndpoints().pricesGetSubscription.fetchObservable(request);
  }
  async removeInactivePricesSubscriptions(id) {
    const request = this.getPricesSubscriptionRequest(id);
    return this.getEndpoints().pricesGetSubscription.removeSubscriptionIfInactive(request);
  }
  getBasicValueUnitGetRequest(id) {
    return { id };
  }
  getBasicValueUnitData(id) {
    var _a2;
    const request = this.getBasicValueUnitGetRequest(id);
    const response = this.getEndpoints().basicValueUnitGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updateBasicValueUnitGet(id) {
    const request = this.getBasicValueUnitGetRequest(id);
    return this.getEndpoints().basicValueUnitGet.updateState(request);
  }
  getSecuritizedDerivativeGetRequest(id, payloadLanguage) {
    const language = getLanguage(payloadLanguage, this.defaultLanguage, this.options);
    return { id, _language: language };
  }
  getSecuritizedDerivativeGetData(payload) {
    var _a2;
    try {
      const idInstrument = this.getInstrumentId(payload);
      const request = this.getSecuritizedDerivativeGetRequest(idInstrument, payload.language);
      const response = this.getEndpoints().securitizedDerivativeGet.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateSecuritizedDerivativeGet(payload) {
    try {
      await this.updateInstrumentGetByNotationData(payload);
      const idInstrument = this.getInstrumentId(payload);
      const request = this.getSecuritizedDerivativeGetRequest(idInstrument, payload.language);
      return this.getEndpoints().securitizedDerivativeGet.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getIndexGetRequest(id, payloadLanguage) {
    const language = getLanguage(payloadLanguage, this.defaultLanguage, this.options);
    return {
      identifier: id,
      identifierType: "idNotation",
      _language: language
    };
  }
  getIndexGetData(payload) {
    var _a2;
    const request = this.getIndexGetRequest(payload.id, payload.language);
    const response = this.getEndpoints().indexGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updateIndexGet(payload) {
    const request = this.getIndexGetRequest(payload.id, payload.language);
    return this.getEndpoints().indexGet.updateState(request);
  }
  getCompanyKeyItemsFiscalYearListByInstrumentRequest(id) {
    const year = new Date().getFullYear();
    return {
      data: {
        identifier: {
          value: id,
          type: "idNotation"
        },
        fiscalYears: {
          start: year,
          end: year
        }
      }
    };
  }
  getCompanyKeyItemsFiscalYearListByInstrumentData(payload) {
    var _a2;
    try {
      const request = this.getCompanyKeyItemsFiscalYearListByInstrumentRequest(payload.id);
      const response = this.getEndpoints().companyKeyItemsFiscalYearListByInstrument.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateCompanyKeyItemsFiscalYearListByInstrument(payload) {
    try {
      const request = this.getCompanyKeyItemsFiscalYearListByInstrumentRequest(payload.id);
      return this.getEndpoints().companyKeyItemsFiscalYearListByInstrument.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getNotationGetRequest(id, payloadLanguage) {
    return {
      identifier: id,
      identifierType: "idNotation",
      _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options)
    };
  }
  getNotationGetData(payload) {
    var _a2;
    const request = this.getNotationGetRequest(payload.id, payload.language);
    const response = this.getEndpoints().notationGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getCurrency(payload) {
    var _a2, _b2, _c2, _d2;
    const currencyIsoCode = (_a2 = this.getNotationGetData(payload)) == null ? void 0 : _a2.valueUnit.isoCode;
    return (_d2 = (_c2 = COMPANY_ESTIMATES_SUPPORTED_CURRENCIES.find((isoCode) => isoCode === currencyIsoCode)) != null ? _c2 : (_b2 = this.options) == null ? void 0 : _b2.fallbackCurrencyIsoCode) != null ? _d2 : this.defaultCompanyEstimatesIsoCurrency;
  }
  async updateNotationGet(payload) {
    const request = this.getNotationGetRequest(payload.id, payload.language);
    return this.getEndpoints().notationGet.updateState(request);
  }
  getCompanyEstimatesListByInstrumentRequest(id, isoCodeCurrency) {
    const year = new Date().getFullYear();
    return {
      data: {
        identifier: {
          value: id,
          type: "idNotation"
        },
        fiscalYears: {
          start: year,
          end: year
        },
        currency: {
          isoCode: isoCodeCurrency
        }
      }
    };
  }
  getCompanyEstimatesListData(payload) {
    var _a2;
    try {
      const currencyIsoCode = this.getCurrency(payload);
      const request = this.getCompanyEstimatesListByInstrumentRequest(payload.id, currencyIsoCode);
      const response = this.getEndpoints().companyEstimatesListByInstrument.getData(request);
      return (_a2 = response == null ? void 0 : response.data.figures[0]) != null ? _a2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateCompanyEstimatesListByInstrument(payload) {
    try {
      await this.updateNotationGet(payload);
      const currencyIsoCode = this.getCurrency(payload);
      const request = this.getCompanyEstimatesListByInstrumentRequest(payload.id, currencyIsoCode);
      return this.getEndpoints().companyEstimatesListByInstrument.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getInstrumentCompliancePropertyListByInstrumentRequest(id, payloadLanguage) {
    const language = getLanguage(payloadLanguage, this.defaultLanguage, this.options);
    return { id, _language: language };
  }
  getInstrumentCompliancePropertyData(payload) {
    var _a2;
    try {
      const idInstrument = this.getInstrumentId(payload);
      const request = this.getInstrumentCompliancePropertyListByInstrumentRequest(idInstrument, payload.language);
      const response = this.getEndpoints().instrumentCompliancePropertyListByInstrument.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateInstrumentCompliancePropertyListByInstrument(payload) {
    try {
      await this.updateInstrumentGetByNotationData(payload);
      const idInstrument = this.getInstrumentId(payload);
      const request = this.getInstrumentCompliancePropertyListByInstrumentRequest(idInstrument, payload.language);
      return this.getEndpoints().instrumentCompliancePropertyListByInstrument.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getFundShareClassGetRequest(identifier, payloadLanguage) {
    const language = getLanguage(payloadLanguage, this.defaultLanguage, this.options);
    return {
      identifier,
      identifierType: "idNotation",
      _language: language
    };
  }
  getFundShareClassData(payload) {
    var _a2;
    try {
      const request = this.getFundShareClassGetRequest(payload.id, payload.language);
      const response = this.getEndpoints().fundShareClassGet.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateFundShareClassGet(payload) {
    try {
      const request = this.getFundShareClassGetRequest(payload.id, payload.language);
      return this.getEndpoints().fundShareClassGet.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getNotationKeyFiguresGetRequest(id, timeSpan) {
    return {
      identifier: id,
      identifierType: "idNotation",
      timeSpan
    };
  }
  getNotationKeyFiguresPerfRelative(id, timeSpan) {
    var _a2;
    const request = this.getNotationKeyFiguresGetRequest(id, timeSpan);
    const response = this.getEndpoints().notationKeyFiguresGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data.performance.relative) != null ? _a2 : null;
  }
  async updateNotationKeyFigures(id, timeSpan) {
    const request = this.getNotationKeyFiguresGetRequest(id, timeSpan);
    return this.getEndpoints().notationKeyFiguresGet.updateState(request);
  }
  getMorningstarFundGetRequest(identifier, payloadLanguage) {
    const language = getLanguage(payloadLanguage, this.defaultLanguage, this.options);
    return { identifier, identifierType: "idNotation", _language: language };
  }
  getMorningstarFundData(payload) {
    var _a2;
    const request = this.getMorningstarFundGetRequest(payload.id, payload.language);
    const response = this.getEndpoints().morningstarFundGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updateMorningstarFundGet(payload) {
    const request = this.getMorningstarFundGetRequest(payload.id, payload.language);
    return this.getEndpoints().morningstarFundGet.updateState(request);
  }
  getMorningstarFundIssuerGetRequest(payload) {
    var _a2;
    const fundData = this.getMorningstarFundData(payload);
    const issuerId = (_a2 = fundData == null ? void 0 : fundData.issuer.id) != null ? _a2 : null;
    if (issuerId === null) {
      throw new Error("could not get morningstar fund issuer id");
    }
    return { id: Number(issuerId) };
  }
  getMorningstarFundIssuerData(payload) {
    var _a2;
    try {
      const request = this.getMorningstarFundIssuerGetRequest(payload);
      const response = this.getEndpoints().morningstarFundIssuerGet.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (e) {
      this.logger.error(e);
      return null;
    }
  }
  async updateMorningstarFundIssuerGet(payload) {
    try {
      await this.updateMorningstarFundGet(payload);
      const request = this.getMorningstarFundIssuerGetRequest(payload);
      return this.getEndpoints().morningstarFundIssuerGet.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getMorningstarFundCategoryListByInstrumentRequest(identifier, payloadLanguage) {
    const language = getLanguage(payloadLanguage, this.defaultLanguage, this.options);
    return { identifier, identifierType: "idNotation", _language: language };
  }
  getFilteredMorningstarFundCategories(payload) {
    var _a2;
    const request = this.getMorningstarFundCategoryListByInstrumentRequest(payload.id, payload.language);
    const response = this.getEndpoints().morningstarFundCategoryListByInstrument.getData(request);
    const filteredFundCategories = response == null ? void 0 : response.data.categories.filter((fundCategory) => {
      return fundCategory.type.id === this.fundCategoryType;
    });
    return (_a2 = filteredFundCategories == null ? void 0 : filteredFundCategories[0]) != null ? _a2 : null;
  }
  async updateMorningstarFundCategoriesListByInstrument(payload) {
    const request = this.getMorningstarFundCategoryListByInstrumentRequest(payload.id, payload.language);
    return this.getEndpoints().morningstarFundCategoryListByInstrument.updateState(request);
  }
  getNotationStatusGetRequest(id, quality) {
    return {
      identifier: id,
      identifierType: "idNotation",
      quality
    };
  }
  getNotationStatusData(payload) {
    var _a2;
    const quality = this.quality.replace("EOD", "DLY");
    const request = this.getNotationStatusGetRequest(payload.id, quality);
    const response = this.getEndpoints().notationStatusGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updateNotationStatusGet(payload) {
    const quality = this.quality.replace("EOD", "DLY");
    const request = this.getNotationStatusGetRequest(payload.id, quality);
    return this.getEndpoints().notationStatusGet.updateState(request);
  }
  getAssetClass(payload) {
    const instrumentGetByNotationData = this.getInstrumentGetByNotationData(payload);
    return mapAssetClass(instrumentGetByNotationData == null ? void 0 : instrumentGetByNotationData.assetClass.code);
  }
  isNonCurrencyMarket(crossReference, assetClass) {
    return crossReference.market.id !== null && crossReference.market.name !== null && assetClass !== "currency";
  }
  isFactsetForexMarket(crossReference, assetClass) {
    var _a2;
    return assetClass === "currency" && Object.values(FactsetFxMarket).includes((_a2 = crossReference.market.id) != null ? _a2 : NaN);
  }
  isMarketAvailable(crossReference, assetClass) {
    return this.isNonCurrencyMarket(crossReference, assetClass) || this.isFactsetForexMarket(crossReference, assetClass);
  }
  getPerformanceBarData(payload) {
    const assetClass = this.getAssetClass(payload);
    if (this.longTermAssetClasses.includes(assetClass)) {
      return [
        {
          label: "factsheetHeader.label.perf1Year",
          value: this.getNotationKeyFiguresPerfRelative(payload.id, "year-1")
        },
        {
          label: "factsheetHeader.label.perf5Years",
          value: this.getNotationKeyFiguresPerfRelative(payload.id, "year-5")
        }
      ];
    }
    return [
      {
        label: "factsheetHeader.label.perf1Week",
        value: this.getNotationKeyFiguresPerfRelative(payload.id, "week-1")
      },
      {
        label: "factsheetHeader.label.perf1Month",
        value: this.getNotationKeyFiguresPerfRelative(payload.id, "month-1")
      }
    ];
  }
  async updatePriceInformation(payload) {
    try {
      await this.updatePricesList([payload.id]);
      const priceData = this.getPricesListData(payload);
      if (priceData) {
        await this.updateBasicValueUnitGet(priceData.valueUnit.id);
      }
      if (this.isPushEnabled) {
        await this.fetchPricesSubscriptionObservable(payload.id);
      }
      return true;
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  async updatePerformanceBarData(payload) {
    try {
      const requests = [];
      await this.updateInstrumentGetByNotationData(payload);
      const assetClass = this.getAssetClass(payload);
      if (this.longTermAssetClasses.includes(assetClass)) {
        requests.push(this.updateNotationKeyFigures(payload.id, "year-1"), this.updateNotationKeyFigures(payload.id, "year-5"));
      } else {
        requests.push(this.updateNotationKeyFigures(payload.id, "week-1"), this.updateNotationKeyFigures(payload.id, "month-1"));
      }
      await Promise.all(requests);
      return true;
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getAdditionalDataTypes(payload) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
    const assetClass = this.getAssetClass(payload);
    return (_h2 = (_g2 = (_c2 = (_b2 = (_a2 = this.options) == null ? void 0 : _a2.assetClass) == null ? void 0 : _b2[assetClass]) == null ? void 0 : _c2.additionalData) != null ? _g2 : (_f2 = (_e2 = (_d2 = this.options) == null ? void 0 : _d2.assetClass) == null ? void 0 : _e2.generic) == null ? void 0 : _f2.additionalData) != null ? _h2 : [];
  }
  getFooterInformationData(payload) {
    const baseInfo = [];
    const instrumentResponse = this.getInstrumentGetByNotationData(payload);
    const assetClass = this.getAssetClass(payload);
    this.getAdditionalDataTypes(payload).forEach((additionalDataType) => {
      var _a2, _b2, _c2, _d2, _e2, _f2;
      if (additionalDataType === "isin" && (instrumentResponse == null ? void 0 : instrumentResponse.isin)) {
        baseInfo.push({
          label: "factsheetHeader.label.isin",
          value: instrumentResponse.isin,
          copyable: true
        });
      } else if (additionalDataType === "wkn" && (instrumentResponse == null ? void 0 : instrumentResponse.nsin.wkn)) {
        baseInfo.push({
          label: "factsheetHeader.label.wkn",
          value: instrumentResponse.nsin.wkn,
          copyable: true
        });
      } else if (assetClass === "index" && additionalDataType === "numberOfConstituents") {
        const indexNotationData = this.getIndexGetData(payload);
        if (indexNotationData == null ? void 0 : indexNotationData.numberConstituents) {
          baseInfo.push({
            label: "factsheetHeader.label.numberOfConstituents",
            value: String(indexNotationData.numberConstituents),
            copyable: false
          });
        }
      } else if (additionalDataType === "country") {
        const countryName = this.getCountryName(payload);
        if (countryName) {
          baseInfo.push({
            label: "factsheetHeader.label.country",
            value: countryName,
            copyable: false
          });
        }
      } else if (additionalDataType === "symbol") {
        const notationGetResponse = this.getNotationGetData(payload);
        if (notationGetResponse == null ? void 0 : notationGetResponse.symbol) {
          baseInfo.push({
            label: "factsheetHeader.label.symbol",
            value: notationGetResponse.symbol,
            copyable: true
          });
        }
      } else if (additionalDataType === "fundIssuer" && this.fundProvider === "morningstar") {
        const fundIssuerResponse = this.getMorningstarFundIssuerData(payload);
        if (fundIssuerResponse == null ? void 0 : fundIssuerResponse.name) {
          baseInfo.push({
            label: "factsheetHeader.label.fundIssuer",
            value: fundIssuerResponse.name,
            copyable: false
          });
        }
      } else if (additionalDataType === "fundCategory") {
        const filteredFundCategory = this.getFilteredMorningstarFundCategories(payload);
        baseInfo.push({
          label: "factsheetHeader.label.fundCategory",
          value: (_a2 = filteredFundCategory == null ? void 0 : filteredFundCategory.name) != null ? _a2 : null,
          copyable: false
        });
      } else if (additionalDataType === "PEA") {
        const instrumentCompliancePropertyData = this.getInstrumentCompliancePropertyData(payload);
        const pea = ((_b2 = instrumentCompliancePropertyData == null ? void 0 : instrumentCompliancePropertyData.findIndex((complianceProperty) => {
          return complianceProperty.id === this.peaID;
        })) != null ? _b2 : -1) >= 0;
        if (pea) {
          baseInfo.push({
            label: "factsheetHeader.label.pea",
            value: "",
            copyable: false
          });
        }
      } else if (additionalDataType === "PME") {
        const instrumentCompliancePropertyData = this.getInstrumentCompliancePropertyData(payload);
        const pme = ((_c2 = instrumentCompliancePropertyData == null ? void 0 : instrumentCompliancePropertyData.findIndex((complianceProperty) => {
          return complianceProperty.id === this.peapmeID;
        })) != null ? _c2 : -1) >= 0;
        if (pme) {
          baseInfo.push({
            label: "factsheetHeader.label.pme",
            value: "",
            copyable: false
          });
        }
      } else if (additionalDataType === "SRD") {
        const instrumentCompliancePropertyData = this.getInstrumentCompliancePropertyData(payload);
        const srd = ((_d2 = instrumentCompliancePropertyData == null ? void 0 : instrumentCompliancePropertyData.findIndex((complianceProperty) => {
          return complianceProperty.id === this.srdID;
        })) != null ? _d2 : -1) >= 0;
        if (srd) {
          baseInfo.push({
            label: "factsheetHeader.label.srd",
            value: "",
            copyable: false
          });
        }
      } else if (additionalDataType === "tradingStatus") {
        const notationStatusGetResponse = this.getNotationStatusData(payload);
        if (notationStatusGetResponse == null ? void 0 : notationStatusGetResponse.tradingStatus) {
          baseInfo.push({
            label: "factsheetHeader.label.tradingStatus",
            value: notationStatusGetResponse.tradingStatus,
            copyable: false
          });
        }
      } else if (additionalDataType === "suspended") {
        const notationStatusGetResponse = this.getNotationStatusData(payload);
        if (typeof (notationStatusGetResponse == null ? void 0 : notationStatusGetResponse.suspended) === "boolean") {
          baseInfo.push({
            label: "factsheetHeader.label.suspended",
            value: this.formatBoolean(notationStatusGetResponse.suspended),
            copyable: false
          });
        }
      } else if (additionalDataType === "marketStatus") {
        const notationStatusGetResponse = this.getNotationStatusData(payload);
        if (typeof (notationStatusGetResponse == null ? void 0 : notationStatusGetResponse.market.isOpen) === "boolean") {
          baseInfo.push({
            label: "factsheetHeader.label.marketStatus",
            value: this.formatBoolean(notationStatusGetResponse.market.isOpen, { truthy: "open", falsy: "close" }),
            copyable: false
          });
        }
      } else if (additionalDataType === "tradingPhase") {
        const notationStatusGetResponse = this.getNotationStatusData(payload);
        if (notationStatusGetResponse == null ? void 0 : notationStatusGetResponse.market.phase) {
          baseInfo.push({
            label: "factsheetHeader.label.tradingPhase",
            value: notationStatusGetResponse.market.phase,
            copyable: false
          });
        }
      } else if (additionalDataType === "expectedDividends") {
        const companyEstimatesData = this.getCompanyEstimatesListData(payload);
        baseInfo.push({
          label: "factsheetHeader.label.expectedDividends",
          value: (_e2 = companyEstimatesData == null ? void 0 : companyEstimatesData.perShare.dividends.mean) != null ? _e2 : null,
          copyable: false
        });
      } else if (additionalDataType === "expectedPriceEarningsRatio") {
        const companyEstimatesData = this.getCompanyEstimatesListData(payload);
        baseInfo.push({
          label: "factsheetHeader.label.expectedPriceEarningsRatio",
          value: (_f2 = companyEstimatesData == null ? void 0 : companyEstimatesData.ratios.priceEarnings.mean) != null ? _f2 : null,
          copyable: false
        });
      }
    });
    return baseInfo;
  }
  getCountryName(payload) {
    var _a2, _b2, _c2, _d2, _e2;
    try {
      const assetClass = this.getAssetClass(payload);
      if (assetClass === "index") {
        const indexNotationData = this.getIndexGetData(payload);
        return (_a2 = indexNotationData == null ? void 0 : indexNotationData.region.name) != null ? _a2 : null;
      } else if (this.isDerivative(assetClass)) {
        const securitizedDerivativeData = this.getSecuritizedDerivativeGetData(payload);
        return (_b2 = securitizedDerivativeData == null ? void 0 : securitizedDerivativeData.countrySecurityRegistration.filter((country) => {
          return country.name;
        }).map((country) => {
          return country.name;
        }).join(", ")) != null ? _b2 : null;
      } else if (assetClass === "stock") {
        const companyKeyItemsData = this.getCompanyKeyItemsFiscalYearListByInstrumentData(payload);
        return (_c2 = companyKeyItemsData == null ? void 0 : companyKeyItemsData.company.country.name) != null ? _c2 : null;
      } else if (this.isFund(assetClass) && this.fundProvider === "mountainview") {
        const fundShareClassData = this.getFundShareClassData(payload);
        return (_d2 = fundShareClassData == null ? void 0 : fundShareClassData.legalEntities.fund.domicile.name) != null ? _d2 : null;
      } else if (this.isFund(assetClass) && this.fundProvider === "morningstar") {
        const fundGetResponse = this.getMorningstarFundData(payload);
        return (_e2 = fundGetResponse == null ? void 0 : fundGetResponse.domicile.name) != null ? _e2 : null;
      }
      return null;
    } catch (e) {
      return null;
    }
  }
  async updateFooterInformationData(payload) {
    try {
      const requests = [];
      await this.updateInstrumentGetByNotationData(payload);
      const assetClass = this.getAssetClass(payload);
      const additionalDataTypes = this.getAdditionalDataTypes(payload);
      for (const additionalDataType of additionalDataTypes) {
        if (assetClass === "index" && additionalDataType === "numberOfConstituents") {
          requests.push(this.updateIndexGet(payload));
        } else if (additionalDataType === "symbol") {
          requests.push(this.updateNotationGet(payload));
        } else if (this.isFund(assetClass) && additionalDataType === "fundIssuer" && this.fundProvider === "morningstar") {
          await this.updateMorningstarFundGet(payload);
          requests.push(this.updateMorningstarFundIssuerGet(payload));
        } else if (this.isFund(assetClass) && additionalDataType === "fundCategory") {
          requests.push(this.updateMorningstarFundCategoriesListByInstrument(payload));
        } else if (this.includesAdditionalData(additionalDataType, ["tradingStatus", "suspended", "marketStatus", "tradingPhase"])) {
          requests.push(this.updateNotationStatusGet(payload));
        } else if (additionalDataType === "PEA" || additionalDataType === "PME" || additionalDataType === "SRD") {
          requests.push(this.updateInstrumentCompliancePropertyListByInstrument(payload));
        } else if (this.includesAdditionalData(additionalDataType, ["expectedDividends", "expectedPriceEarningsRatio"])) {
          requests.push(this.updateCompanyEstimatesListByInstrument(payload));
        } else if (additionalDataType === "country") {
          requests.push(this.updateCountryData(payload));
        }
      }
      await Promise.all(requests);
      return true;
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  async updateCountryData(payload) {
    try {
      await this.updateInstrumentGetByNotationData(payload);
      const assetClass = this.getAssetClass(payload);
      if (assetClass === "stock") {
        return await this.updateCompanyKeyItemsFiscalYearListByInstrument(payload);
      } else if (this.isFund(assetClass) && this.fundProvider === "mountainview") {
        return await this.updateFundShareClassGet(payload);
      } else if (this.isFund(assetClass) && this.fundProvider === "morningstar") {
        return await this.updateMorningstarFundGet(payload);
      } else if (this.isDerivative(assetClass)) {
        return await this.updateSecuritizedDerivativeGet(payload);
      } else if (assetClass === "index") {
        return await this.updateIndexGet(payload);
      }
      return false;
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  isDerivative(assetClass) {
    return this.derivatives.includes(assetClass);
  }
  isFund(assetClass) {
    return assetClass === "fund" || assetClass === "etf";
  }
  includesAdditionalData(additionalDataType, types) {
    return types.includes(additionalDataType);
  }
  formatBoolean(value, options = { truthy: "true", falsy: "false" }) {
    if (value === void 0 || value === null) {
      return null;
    }
    return value ? options.truthy : options.falsy;
  }
}

export { FactsheetHeaderStoreModuleFactory };
